import './index.css';
import { TextProfileIcon } from '../TextProfileIcon';
import { callIdIcon, dateIcon, pinIcon, phoneIcon } from '../../assets';
import { observer } from 'mobx-react';
import ChatStore from '../../stores/ChatStore';
import { formatDate } from '../../helpers/functions';
import AuthStore from '../../stores/AuthStore';
import strings from '../../localization';

const CallSessionInformation = () => {

  const user = AuthStore.user;
  const name = user?.name;
  const surname = user?.surname;
  const fullName = `${name} ${surname}`;

  const callState = ChatStore.callState;
  const callId = callState?._id;
  const date = formatDate(callState?.createdAt);
  const pin = callState?.pin;
  const customer = callState?.customer;

  if (!user || !callState) {
    return null;
  }

  return (
    <div className="call-session-information-container">

      <div className="call-session-information-profile">
        <TextProfileIcon text={fullName} />
        <div className="call-session-information-profile-name">
          <span>{fullName}</span>
          <span>ID: {callId}</span>
        </div>
      </div>

      <div className="call-session-information-items">
        <div className="call-session-information-item">
          <img src={callIdIcon} alt="call-id" />
          <span>{strings.callId}</span>
          <span>{callId}</span>
        </div>
        <div className="call-session-information-item">
          <img src={dateIcon} alt="date" />
          <span>{strings.date}</span>
          <span>{date}</span>
        </div>
        <div className="call-session-information-item">
          <img src={pinIcon} alt="pin" />
          <span>{strings.pin}</span>
          <span>{pin}</span>
        </div>
        <div className="call-session-information-item">
          <img src={phoneIcon} alt="phone" />
          <span>{strings.phone}</span>
          <span>{customer}</span>
        </div>
      </div>

    </div>
  );
};

export default observer(CallSessionInformation);


// LOCALIZATION WAITING